module.exports = __webpack_public_path__ + "img/MiddleSide_right.75b776a5.jpg";